import script from "./MainDesktop.vue?vue&type=script&lang=ts&setup=true"
export * from "./MainDesktop.vue?vue&type=script&lang=ts&setup=true"

import "./MainDesktop.vue?vue&type=style&index=0&id=7ccbd84d&lang=scss&scoped=true"

import exportComponent from "/Users/BlackPaw/Developer/acebed_vue3_web/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ccbd84d"]])

export default __exports__